import type { NumberFormatConfig } from '../types';
import {
  validateDecimalPlaces,
  validateDecimalSeparator,
  validateThousandsSeparator,
} from '../utils';

interface NumberFormatterParams extends NumberFormatConfig {
  decimalPlaces: number;
}

export const numberFormatter: (params: NumberFormatterParams) => (n: number) => string =
  (params) => (n) => {
    const decimalPlaces = validateDecimalPlaces(params.decimalPlaces);
    const areDecimalPlacesFixed = params.areDecimalPlacesFixed ?? false;
    const decimalSeparator = validateDecimalSeparator(params.decimalSeparator);
    const thousandsSeparator = validateThousandsSeparator(params.thousandsSeparator);

    const locale = decimalSeparator === '.' ? 'en' : 'de';

    return n
      .toLocaleString(locale, {
        minimumFractionDigits: areDecimalPlacesFixed ? decimalPlaces : undefined,
        maximumFractionDigits: decimalPlaces,
      })
      .replace(locale === 'en' ? '.' : ',', decimalSeparator)
      .replaceAll(locale === 'en' ? ',' : '.', thousandsSeparator);
  };
